import api from './api';

async function fetchDocuments(category, params) {
  return api.get(`/documents/${category}`, params)
}

export { fetchDocuments };